module.exports = __webpack_public_path__ + "static/media/img_qudao11@2x.95738122.png";